/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  input,
  model,
  OnInit,
  output,
  viewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormErrorDirective } from '../../directives/form-error.directive';
import { Hint } from '../hint/hint.component';
import { Icon } from '../icon/icon.component';
import { Label } from '../label/label.component';
import { BaseInput } from './base-input';

@Component({
  selector: 'app-input',
  host: {
    ngSkipHydration: 'true',
  },
  standalone: true,
  imports: [Icon, Label, CommonModule, Hint],
  styleUrl: './input.component.scss',
  templateUrl: './input.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: Input,
      multi: true,
    },
  ],
  hostDirectives: [FormErrorDirective],
})
export class Input
  extends BaseInput<any>
  implements AfterViewInit, OnInit, ControlValueAccessor
{
  inputClick = output<void>();
  inputFocus = output<void>();
  inputBlur = output<void>();
  inputKeydown = output<KeyboardEvent>();
  inputRef = viewChild<ElementRef<HTMLInputElement>>('inputRef');
  inputValue = model<string>();

  prefix = input<string>('');
  suffix = input<string>();
  prefixIcon = input<string>();
  suffixIcon = input<string>();
  icon = input<string>();
  list = input<string>();

  async ngAfterViewInit() {
    // 초기화
    setTimeout(() => {
      if (this.value()) {
        this.inputRef()!.nativeElement.value = this.value() || '';
      }
    }, 500);

    // 값 변경 감지
    this.value$.subscribe((value) => {
      if (value) {
        this.inputRef()!.nativeElement.value = value.toString() || '';
      }
    });

    // 디바운스 함수 정의
    const debounce = (func: (...args: any[]) => void, delay: number) => {
      let timeoutId: ReturnType<typeof setTimeout>;
      return (...args: any[]) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func(...args), delay);
      };
    };

    // 입력 처리 함수
    const handleInput = (event: Event) => {
      const inputElement = event.target as HTMLInputElement;
      let inputValue = inputElement.value;

      if (this.inputMode() === 'numeric') {
        inputValue = inputValue.replace(/\D/g, ''); // 숫자만 남기기
        inputElement.value = inputValue; // UI 업데이트
      }

      this.value.set(inputValue); // 상태 업데이트
    };

    // 디바운스 적용
    const debouncedInputHandler = debounce(handleInput, this.debounce()!); // 300ms 디바운스

    // 네이티브 oninput에 디바운스 함수 연결
    this.inputRef()!.nativeElement.oninput = debouncedInputHandler;
  }

  /**
   * @description input element의 change 이벤트 발생 시 호출되는 함수
   * (type이 date인 경우에만 호출)
   */
  handleChange() {
    if (this.type() === 'date') {
      this.value.set(this.inputRef()!.nativeElement.value);
    }
  }
}
